import React from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useIsMobile } from '../hooks/useIsMobile';

function Login() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const isMobile = useIsMobile();

  const onFinish = async (values) => {
    try {
      const res = await api.post('/auth/login', values);
      if (res.code === 200) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        message.success('登录成功');
        navigate('/orders');
      }
    } catch (err) {
      // 错误已在拦截器中处理
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: isMobile ? 16 : 24
    }}>
      <Card style={{ width: isMobile ? '100%' : 400, maxWidth: 400, borderRadius: 8 }}>
        <h2 style={{ textAlign: 'center', marginBottom: isMobile ? 24 : 32, fontSize: isMobile ? 18 : 20 }}>自媒体涨粉管理</h2>
        <Form
          form={form}
          onFinish={onFinish}
          size="large"
        >
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined />} placeholder="用户名" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              登录
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center', color: '#999', fontSize: 12 }}>
          默认管理员账号: admin / admin123
        </div>
      </Card>
    </div>
  );
}

export default Login;
